import axios from 'axios'
export default {
    getConsumptionList: function (queryParams) {
        return axios.get(`/meilv/scs/account/v1/voucher/statistics`, {
            params: queryParams
        });
    },
    getDeals: function (queryParams) {
        return axios.get(`/meilv/scs/account/v1/voucher/deallist`, {
            params: queryParams
        });
    },
    getAllConsumptionList: function (queryParams) {
        return axios.get(`/meilv/scs/account/v1/voucher/log`, {
            params: queryParams
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/verifyHistory.js